import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'mage-react-router';
import cms from '@moka-fe/cms';
import classNames from 'classnames';
import moment from 'moment';
import { Button, Spacing } from 'sugar-design';
import * as sdf from '@SDFoundation';

import { DATE_FORMAT, PROTECT_TYPES } from '@/constants/common';
import { ERROR_CODES } from '@/tools/mokaRequest/errorCode';
import { getI18n } from '@/utils/i18n';

import emptyStatusSvg from '@/static/images/emptyStatus.svg';
import inputSuccessPng from '@/static/images/inputSuccess.png';

const i18n = getI18n();

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.sessionResult = null;
  }

  UNSAFE_componentWillMount() {
    let sessionResult = sessionStorage.getItem('sessionResult');
    this.sessionResult = sessionResult && JSON.parse(sessionResult);
  }

  render() {
    const {
      uploadResult,
      match: {
        params: { orgId, jobId, contractId },
      },
      location: { pathname, query },
    } = this.props;
    // recommend or update
    // set session data for reload
    let uploadData = null;
    if (Object.keys(uploadResult).length !== 0) {
      sessionStorage.setItem('sessionResult', JSON.stringify(uploadResult));
      uploadData = uploadResult;
    } else {
      uploadData = this.sessionResult;
      sessionStorage.setItem('sessionResult', JSON.stringify(uploadData));
    }
    const update = pathname && pathname.indexOf('recommend') < 0;

    const data = uploadData?.data || {};
    const showAppliedAt = !data.headhunterHiddenCandidateAppliedAt;
    let text = '';
    let title = '';
    let needCandidateConfirmText = '';
    let iconType = 'success';
    if (uploadData.result === 'success') {
      // 成功推荐
      title = update ? i18n.t`更新成功` : i18n.t`猎头上传成功`;
      text = update ? '' : i18n.t`已成功提交推荐信息，请静待佳音！`;
      if (data.merged) {
        // 申请被合并的情况，重复推荐拒绝
        iconType = 'error';
        title = update ? i18n.t`更新失败` : i18n.t`猎头推荐失败`;
        text = update ? (
          i18n.t`该候选人在系统中已存在相同的申请，本次推荐无效`
        ) : (
          <Spacing direction="vertical">
            <div>{i18n.t`您已推荐候选人「${data.candidateName}」到相同的职位`}</div>
            <div>{i18n.t`无法重复推荐，本次推荐无效，感谢推荐！`}</div>
          </Spacing>
        );
      } else if (data.latestAppliedAt) {
        // 精准查重查到了，重复推荐
        iconType = 'success';
        title = update ? i18n.t`更新成功：候选人重复` : i18n.t`猎头上传成功`;
        text = (
          <Spacing direction="vertical">
            <div> {i18n.t`已成功提交推荐信息，请静待佳音！`}</div>
            <div> {i18n.t`您推荐的候选人「${data.candidateName}」在系统中已经存在`}</div>
            {showAppliedAt && (
              <div>{i18n.t`上次申请时间为${moment(data.latestAppliedAt).format(DATE_FORMAT)}`}</div>
            )}
          </Spacing>
        );
      } else if (data.hasSimilarCandidate) {
        // 疑似查重查到了，成功推荐（疑似）
        const timeinfo = data.similarCandidateLatestApplicationAt
          ? i18n.t`上次申请时间为${moment(data.similarCandidateLatestApplicationAt).format(
              DATE_FORMAT
            )}`
          : '';
        text = (
          <Spacing direction="vertical">
            <div> {i18n.t`已成功提交推荐信息，请静待佳音！`}</div>
            <div>{i18n.t`您推荐的候选人「${data.candidateName}」与系统中候选人疑似重复`}</div>
            {showAppliedAt && <div>{timeinfo}</div>}
          </Spacing>
        );
      }
      if (data.candidateConfirm || data.hrConfirm || data.pending) {
        title = data.candidateConfirm
          ? i18n.t`提交成功，等待候选人确认`
          : i18n.t`提交成功，等待HR确认`;
        text = data.candidateConfirm
          ? i18n.t`已成功提交推荐信息，请耐心等待候选人确认`
          : i18n.t`已成功提交推荐信息，请耐心等待HR确认`;

        if (data.candidateConfirm) {
          needCandidateConfirmText = i18n.t`重要提示：基于合规要求，候选人同意后才能进入正式招聘流程。请尽快通知候选人查收邮件并完成确认授权。`;
        }
      }
    } else if (uploadData.result === 'error') {
      // 失败的情况
      iconType = 'error';
      title = update ? i18n.t`更新失败` : i18n.t`猎头推荐失败`;
      if (data.code === ERROR_CODES[701012]) {
        // 超过猎头投递次数限制
        text = <p>{data.msg}</p>;
      } else if (data.reason === PROTECT_TYPES.HEADHUNTER_LOCK_IN_PROCESS) {
        // 流程中存在
        text = update ? (
          ''
        ) : (
          <Spacing direction="vertical">
            <div> {i18n.t`候选人在招聘流程中，无法重复推荐，本次推荐无效!`}</div>
            <div>{i18n.t`您推荐的候选人「${data.candidateName}」正在招聘流程中`}</div>
            {showAppliedAt && (
              <div>{i18n.t`上次申请时间为${moment(data.latestAppliedAt).format(DATE_FORMAT)}`}</div>
            )}
          </Spacing>
        );
      } else if (data.code === ERROR_CODES[701026]) {
        title = i18n.t`查重进行中，请稍后查看推荐结果`;
        text = i18n.t`系统启用了AI查重，预计需要几分钟时间，请稍后前往“推荐记录”页面查看推荐结果`;
      } else if (data.code === ERROR_CODES[701027]) {
        title = i18n.t`候选人重复，无法推荐`;
        text = i18n.t`请稍后前往“推荐记录”页面查看推荐结果`;
      } else if (data.code === ERROR_CODES[400222]) {
        text = i18n.t`用户没有更新的权限`;
      } else {
        // 保护期拒绝
        text = update ? (
          ''
        ) : (
          <Spacing direction="vertical">
            <div> {i18n.t`保护期内无法重复推荐，本次推荐无效!`}</div>
            <div>
              {data.reason === PROTECT_TYPES.OWN_PROTECT
                ? i18n.t`您推荐的候选人「${data.candidateName}」在系统中已存在`
                : i18n.t`您推荐的候选人「${data.candidateName}」已被其他人推荐`}
            </div>
            {showAppliedAt && (
              <div>{i18n.t`上次${
                data.reason === PROTECT_TYPES.OWN_PROTECT ? i18n.t`申请` : i18n.t`推荐`
              }时间为${moment(data.latestAppliedAt).format(DATE_FORMAT)}`}</div>
            )}
          </Spacing>
        );
      }
    }
    return (
      <div>
        <div className="upload-candidate-result">
          {iconType === 'error' && <img width="72" src={emptyStatusSvg} />}
          {iconType === 'success' && <img width="72" src={inputSuccessPng} />}
          <div className={classNames('upload-candidate-result__title', sdf.heading60)}>{title}</div>
          {needCandidateConfirmText && (
            <div
              className={classNames(
                'upload-candidate-result__text',
                sdf.bodySecondary,
                cms.mgb8,
                cms.mgx24
              )}
            >
              {needCandidateConfirmText}
            </div>
          )}
          <div className={classNames('upload-candidate-result__text', sdf.bodySecondary)}>
            {text}
          </div>
          <div className="upload-candidate-result__buttons">
            {!update && (
              <Link
                className="btn-wrapper"
                to={`/headhunters/${orgId}/recommend/${jobId}/${contractId}?headhunterType=${
                  query?.headhunterType ?? ''
                }`}
              >
                <Button className="btn">{i18n.t`继续投递`}</Button>
              </Link>
            )}
            <Link
              className="btn-wrapper"
              to={`/headhunters/${orgId}/org/${update ? 'applications' : 'jobs'}`}
            >
              <Button type="secondary" className="btn">{i18n.t`返回`}</Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Result.propTypes = {
  uploadResult: PropTypes.object,
};

// trigger rebuild
export default connect((state) => ({ uploadResult: state.applications.uploadResult }))(Result);
